export const HTO_CART_MODE = {
    SUCCESS_ORDER: 'order',
    MIXED_NOT_AVAILABLE: 'learn_more',
    MIXED_NOT_SELECTED: 'mixed',
    INVALID_COUPON: 'invalid_coupon',
    GIFT_CERTIFICATE: 'gift_cert_applied',
};

export const HTO_SESSION_STORAGE_TITLE = 'hto_mode';

export const HTO_SEGMENTS = {
    USE_HTO: 'use-hto',
    NO_USE_HTO: 'no-hto-use',
    UNKNOWN: 'unknown',
};

export const HTO_PDP_MODE = {
    PREFER_HTO: 'prefer_hto',
    PREFER_BUY_NOW: 'prefer_buy_now',
    NO_HTO: 'no_hto',
    HTO_MESSAGE: 'hto_message',
} as const;

export const HTO_PDP_URL_PARAMETER = 'htopdp-on';

export const CURRENT_HTO_SEGMENT = 'currentHtoSegment';
